/**
 * Created by Administrator on 2017/6/5.
 */
/*更新路由方向*/
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION';




// WEBPACK FOOTER //
// ./src/store/types.js